import { UsersModal, LiteUsersModal, AdvisorUsersModal } from './UsersModal.jsx';

const UsersModalMap = {
  UsersModal,
  LiteUsersModal,
  AdvisorUsersModal
};

export default UsersModalMap;